import React, { useState, useEffect } from 'react'
import { Panel, Placeholder } from 'rsuite'
import ReactECharts from 'echarts-for-react'
import { CHART_THEME } from '../../../constants/project'
import { cloneDeep } from 'lodash-es'
import { getSummary5Year } from '../../../redux/actions/auditDashboard'

export default function SummaryOf5YearChart({ request }) {
  const [schema, setSchema] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [chartOption, setChartOption] = useState()

  useEffect(() => {
    handleGetSchema()
  }, [request])

  const handleGetSchema = async () => {
    setIsLoading(true)
    try {
      const response = await getSummary5Year(request)
      // const response = mockSchema
      // console.log('getSummary5Year==>', response)
      let charts = cloneDeep(chartSchema)

      let seriesDatas = []
      response?.chartDatas.forEach((e) => {
        let seriesData = cloneDeep(seriesDataSchema)

        seriesData.name = e.name
        seriesData.data = e.value

        seriesDatas.push(seriesData)
      })

      charts.title.text = response?.chartTitle || 'แสดงร้อยละ(%) ระดับคะแนน 5 ปี'
      charts.xAxis[0].data = response?.category || []
      charts.series = seriesDatas

      // console.log(JSON.stringify(charts))

      setSchema(response)
      setChartOption(charts)
    } catch (e) {
      console.log('error ', e)
      // setError({})
    }
    setIsLoading(false)
  }

  return (
    <>
      {schema && (
        <Panel
          collapsible
          defaultExpanded
          header={schema.header}
          bordered
          style={{ marginTop: 20 }}
          shaded
        >
          {isLoading && <Placeholder.Graph active />}
          {chartOption && (
            <ReactECharts
              theme={CHART_THEME}
              option={chartOption}
              style={{ minHeight: '400px', width: '100%' }}
              className={'react_for_echarts'}
            />
          )}
        </Panel>
      )}
    </>
  )
}

const labelOption = {
  show: true,
  rotate: 360,
  formatter: '{c} %  ',
  fontSize: 16,
  rich: {
    name: {},
  },
}

const seriesDataSchema = {
  name: '',
  type: 'line',
  // xAxisIndex: 1,
  smooth: true,
  emphasis: {
    focus: 'series',
  },
  data: [],
  label: labelOption,
}

const colors = ['#41b596', '#ffc184', '#63c2ff', '#b6a2de', '#dd8b90']
const chartSchema = {
  title: {
    text: '',
    subtext: '',
    left: 'left',
    top: '10',
    textStyle: {
      color: '#008acd',
      opacity: '0.7',
      fontWeight: '400',
      fontSize: '1rem',
    },
  },
  color: colors,
  tooltip: {
    trigger: 'axis',
  },
  toolbox: {
    show: true,
    feature: {
      //dataView: { show: true, readOnly: false },
      saveAsImage: { show: true, title: 'บันทึกเป็นรูป' },
    },
  },
  legend: {
    top: '40',
    left: 'center',
  },
  grid: {
    left: '3%',
    right: '3%',
    top: '80',
    bottom: '20',
    containLabel: true,
  },
  xAxis: [
    {
      type: 'category',
      axisTick: {
        alignWithLabel: true,
      },
      axisLine: {
        onZero: false,
        lineStyle: {
          color: colors[1],
        },
      },
      data: [],
    },
  ],
  yAxis: [
    {
      type: 'value',
    },
  ],
  series: [],
}
